// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Albania */
const AL = /^(?:6(?:[78][2-9]|9\d)\d{6})$/;

export default AL;
